const expression = {
  field: null,
  operator: null,
  value: {
    name: '',
    code: ''
  },
  valueType: 'value'
};

export default expression;
